import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'toEnum' })
export class ToEnumPipe implements PipeTransform {
  transform(value: number | string, enumType: any): any {
    if (typeof value === 'string') {
      return value;
    }
    if (enumType[value] === enumType[value].toUpperCase()) {
      return enumType[value];
    } else {
      return enumType[value]
        .split(/(?=[A-Z])/)
        .join()
        .replace(',', ' ');
    }
  }
}
